export const generateSearchPriceParam = (
  metaKey: string,
  metaValue: string
) => {
  return `metadata['${metaKey}']:'${metaValue}'`
}
